import * as React from 'react';

function SvgArrowBigRight(props) {
  return (
    <svg width={21} height={36} xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M.596 3.424A2 2 0 013.404.576l17 16.762a2 2 0 01-.07 2.913l-17 15.238a2 2 0 11-2.669-2.978l15.416-13.819L.596 3.424z"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default SvgArrowBigRight;
